import { render } from "./UiExportMenu.vue?vue&type=template&id=85fda4d2&ts=true"
import script from "./UiExportMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiExportMenu.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiExportMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85fda4d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85fda4d2', __exports__)) {
    api.reload('85fda4d2', __exports__)
  }
  
  module.hot.accept("./UiExportMenu.vue?vue&type=template&id=85fda4d2&ts=true", () => {
    api.rerender('85fda4d2', render)
  })

}


export default __exports__